module.exports = new __parcel__URL__("progress-default-story-points--dark.5837f909.svg").toString();